import { RegisterStepsList } from './RegisterSteps.types';

export const getRegisterStepPath = (step: RegisterStepsList) => {
  switch (step) {
    case RegisterStepsList.SignUp:
      return '/signup';
    case RegisterStepsList.Entity:
      return '/entity';
    default:
      return '/signup';
  }
};
